import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { ApiService } from '../http/api.service';

export function getSvg(apiService: ApiService, src: EIconPath): Promise<string> {
  return apiService.getSvg(src).then((response) => response.text());
}
